import React, { HTMLAttributes, PropsWithChildren } from 'react';
import styles from './IconButton.module.scss';
import cls from 'classnames';

export function IconButton({
  children,
  className,
  icon,
  rounded,
  square,
  ...rest
}: PropsWithChildren<IconButtonProps>) {
  return (
    <button
      className={cls(styles.iconButton, {
        className,
        [styles.fullRounded]: rounded,
        [styles.square]: square,
      })}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}

export type IconButtonProps = HTMLAttributes<HTMLButtonElement> & {
  icon: React.ReactElement;
  rounded?: boolean;
  square?: boolean;
};
